import { useTranslation } from 'next-i18next';
import { useState } from 'react';

import { useAnimation } from '@/hooks';
import { NS } from '@/constants';

import { useScreenSizeContext } from '@/components/ScreenSize.context';
import { useAppDispatch, useAppSelector } from '@/redux';
import { hideFullScreen } from '@/redux/slices/gui.slice';

import FullScreenContainerV2 from '@/components/layout/modals/FullScreenContainerV2';

import styles from './SortMobile.module.scss';
import { FULL_SCREEN_CONTAINER_MOBILE } from '@/constants/gui';
import { SORT } from '@/constants/categ';
import { ANIMATION } from '@/constants/animation';

const animationMenuModal = {
  opening: ANIMATION.FROM_LEFT,
  closing: ANIMATION.TO_LEFT,
  openingMobile: ANIMATION.FROM_LEFT,
  closingMobile: ANIMATION.TO_LEFT
};

export const SortMobile = ({ selectedSort, onChange, isProducerCategory, onCloseFilterCU = undefined }) => {
  const { t } = useTranslation(NS.COMMON);
  const [currentSort, setCurrenSort] = useState(selectedSort);
  const dispatch = useAppDispatch();
  const isSortMobileVisible = useAppSelector(({ gui }) => gui.isSortMobileVisible);
  const { animationState: animation, handleCloseModal } = useAnimation(animationMenuModal);
  const isMobile = useScreenSizeContext().isMobile;

  const hideSort = () => {
    handleCloseModal();
    setTimeout(() => {
      dispatch(hideFullScreen({ fullScreenType: FULL_SCREEN_CONTAINER_MOBILE.SORT, onHide: undefined, isMobile }));
    }, ANIMATION.DELAY);
  };

  const closeSort = () => {
    onCloseFilterCU?.();
    handleCloseModal();
    setTimeout(() => {
      dispatch(hideFullScreen({ fullScreenType: FULL_SCREEN_CONTAINER_MOBILE.SORT, onHide: undefined, isMobile }));
    }, ANIMATION.DELAY);
  };

  const save = () => {
    onChange(currentSort);
    hideSort();
  };

  const enhancedSort = [
    ...SORT,
    isProducerCategory && { value: 12, label: 'byMillesimeAsc' },
    isProducerCategory && { value: 13, label: 'byMillesimeDesc' },
  ].filter(Boolean);

  const designSystemHeaderProps = {
    title: t('category:sort'),
    whichButton: 'bothButtons',
    onReturnClick: hideSort,
    onCloseClick: closeSort,
  } as const;

  const designSystemFooterProps = {
    confirm: {
      label: t('btn.apply'),
      action: save
    }
  };

  return (
    <FullScreenContainerV2
      designSystemHeader={designSystemHeaderProps} designSystemFooter={designSystemFooterProps}
      isOpen={isSortMobileVisible} animationClass={animation} onClose={hideSort}
      padding="none" classNames={{ container: styles.container, content: styles.content }}
    >
      {enhancedSort.map((sort, i) => (
        <div className={styles.radio} key={i}>
          <input
            className={styles.input}
            type="radio"
            name="sort"
            id={`${sort.value}`}
            value={sort.value}
            onClick={(e: any) => setCurrenSort(+e.target.value)}
            checked={sort.value === currentSort}
            data-test-id="input"
          />
          <label htmlFor={`${sort.value}`} className={styles['radioLabel']}></label>
          <label className={styles.label} data-test-id="label" onClick={(e: any) => setCurrenSort(parseInt(e.target.id))} id={`${sort.value}`}>
            {t(`category:results.${sort.label}`)}
          </label>
        </div>
      ))}
    </FullScreenContainerV2>
  );
};

export default SortMobile;
